import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoor = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7.33333 13.3333H1.33333",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.33333 3.04133V13.8127C7.33336 13.9139 7.35646 14.0139 7.40087 14.1049C7.44528 14.1959 7.50984 14.2756 7.58965 14.3379C7.66946 14.4002 7.76242 14.4436 7.86148 14.4646C7.96053 14.4856 8.06308 14.4838 8.16133 14.4593L12.6667 13.3333V3.708C12.6666 3.41067 12.5672 3.12189 12.3842 2.88755C12.2012 2.65322 11.9451 2.48677 11.6567 2.41467L8.99 1.748C8.7935 1.69888 8.58839 1.69518 8.39025 1.73717C8.1921 1.77916 8.00613 1.86574 7.84644 1.99034C7.68675 2.11494 7.55755 2.27429 7.46865 2.45628C7.37974 2.63827 7.33347 2.83879 7.33333 3.04133Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.33333 2.66667H5.33333C4.97971 2.66667 4.64057 2.80714 4.39052 3.05719C4.14048 3.30724 4 3.64638 4 4V13.3333",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33333 8H9.34",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6667 13.3333H12.6667",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDoor;
